import React, { useEffect, useRef } from "react";

import { monitorForElements } from "@atlaskit/pragmatic-drag-and-drop/element/adapter";
import { autoScrollForElements } from "@atlaskit/pragmatic-drag-and-drop-auto-scroll/element";

import { CenterSection, SideSection, ParentContainer } from "./styles";
import {
  SidePositionOptions,
  SideViewWrapper,
} from "../Viewers/ResourceTaskViewer/SideViewWrapper";

interface ResourceViewerLayoutProps {
  leftSection?: React.ReactNode;
  rightSection?: React.ReactNode;
  children?: React.ReactNode;
  onDrop?: (args: {
    source: {
      data: any;
      element: Element;
    };
    location: {
      current: {
        dropTargets: Array<{
          data: any;
          element: Element;
        }>;
      };
      initial: {
        dropTargets: Array<{
          data: any;
          element: Element;
        }>;
      };
    };
  }) => void;
  onDragStart?: (args: {
    source: {
      data: any;
      element: Element;
    };
  }) => void;
  onDragUpdate?: (args: {
    source: {
      data: any;
      element: Element;
    };
    location: {
      current: {
        dropTargets: Array<{
          data: any;
          element: Element;
        }>;
      };
    };
  }) => void;
}

export const ResourceViewerLayout = (props: ResourceViewerLayoutProps) => {
  const { children, leftSection, rightSection, onDrop, onDragStart, onDragUpdate } = props;

  const centerSectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    return monitorForElements({
      onDragStart: ({ source }) => {
        if (onDragStart) {
          onDragStart({ source });
        }
      },
      onDrag: ({ source, location }) => {
        if (onDragUpdate) {
          onDragUpdate({ source, location });
        }
      },
      onDrop: ({ source, location }) => {
        if (onDrop) {
          onDrop({ source, location });
        }
      },
    });
  }, [onDrop, onDragStart, onDragUpdate]);

  // set up auto-scroll for the main board center section
  useEffect(() => {
    const element = centerSectionRef.current;
    if (!element) return;

    return autoScrollForElements({
      element,
      getAllowedAxis: () => "vertical",
    });
  }, []);

  return (
    <ParentContainer>
      <SideViewWrapper sidePosition={SidePositionOptions.LEFT}>
        <SideSection border="right">{leftSection}</SideSection>
      </SideViewWrapper>

      <CenterSection ref={centerSectionRef}>{children}</CenterSection>

      <SideViewWrapper sidePosition={SidePositionOptions.RIGHT}>
        <SideSection border="left">{rightSection}</SideSection>
      </SideViewWrapper>
    </ParentContainer>
  );
};
